/** Shared Q&A used on the marketing landing FAQ and /faq page. */
export const FAQ_WHAT_IS_MILLET_BRAND = {
  question: 'What is Millet?',
  answer:
    'Millet is a live shopping marketplace. Find creators, compare rates, run the collab, and track shows and payouts in one place.',
};

export const FAQ_WHAT_IS_MILLET_INFLUENCER = {
  question: 'What is Millet?',
  answer:
    'Millet is a live shopping marketplace. Build your profile, take live and short-video collabs, and manage invites and pay in one app.',
};

export const FAQ_HOW_DO_PAYMENTS_WORK = {
  question: 'How do payments work?',
  answer:
    'Payments go through Stripe. Rates and live dates stay on Millet so you always know what is owed.',
};

export const FAQ_HOW_GET_INVITED = {
  question: 'How do I get invited?',
  answer:
    'Keep your profile current. Brands search by niche and platform, then invite you—or you apply to open campaigns.',
};

export const FAQ_CAMPAIGN_TYPES = {
  question: 'What campaigns can I join?',
  answer:
    'Live shopping and short video—launches, drops, and demos. You see the rate and timeline before you accept.',
};

export const FAQ_NEGOTIATE_RATES = {
  question: 'Can I negotiate rates?',
  answer:
    'Yes. Brands send offers and you can counter. Lock rate and deliverables before the live.',
};

/** Full FAQ page: sidebar sections + accordion copy (standalone page). */
export const FAQ_SECTIONS = [
  {
    id: 'getting-started',
    title: 'Getting Started',
    items: [
      FAQ_WHAT_IS_MILLET_BRAND,
      {
        question: 'How does Millet work?',
        answer:
          'Brands invite creators and run collabs in one place. Creators accept, deliver, and get paid. Both sides see the same journey.',
      },
      {
        question: 'Who should use Millet?',
        answer:
          'Brands that want structured live-shopping partnerships, and creators who want clear rates, timelines, and pay.',
      },
    ],
  },
  {
    id: 'for-creators',
    title: 'For Creators',
    items: [
      FAQ_HOW_GET_INVITED,
      {
        question: 'How do I get paid?',
        answer:
          'Complete the deliverables and Millet pays you through Stripe. Timing follows the terms you accept.',
      },
      FAQ_CAMPAIGN_TYPES,
    ],
  },
  {
    id: 'for-brands',
    title: 'For Brands',
    items: [
      {
        question: 'How do I find creators?',
        answer:
          'Search by category, audience, and goals. Shortlist, then send invites without leaving Millet.',
      },
      {
        question: 'How do invites work?',
        answer:
          'Send campaign details and terms. Creators accept, decline, or counter. Once agreed, the collab stays in Millet.',
      },
      {
        question: 'How do I track performance?',
        answer:
          'Campaign and collab views show progress, deliverables, and KPIs in one place.',
      },
    ],
  },
  {
    id: 'campaigns',
    title: 'Campaigns',
    items: [
      {
        question: 'What happens after I accept?',
        answer:
          'Milestones, deadlines, and the brief live in Millet. Both sides follow briefs, submission, revisions, and wrap-up there.',
      },
      {
        question: 'How does content submission work?',
        answer:
          'Creators upload or link deliverables. Brands review, request changes, and approve on the campaign record.',
      },
      {
        question: 'What is the collaboration journey?',
        answer:
          'Invite or apply, align on scope, submit, revise, approve, and get paid—visible to both sides at every step.',
      },
    ],
  },
  {
    id: 'payments',
    title: 'Payments',
    items: [
      FAQ_HOW_DO_PAYMENTS_WORK,
      {
        question: 'When are payouts sent?',
        answer:
          'Usually after deliverables are approved. The exact timing is in the terms you accept.',
      },
      {
        question: 'Can we negotiate rates?',
        answer: FAQ_NEGOTIATE_RATES.answer,
      },
    ],
  },
  {
    id: 'trust-safety',
    title: 'Trust & Safety',
    items: [
      {
        question: 'How is my data protected?',
        answer:
          'Brands see what they need to run campaigns. Sensitive personal data is not exposed for browsing. See our Privacy Policy.',
      },
      {
        question: 'What if something goes wrong?',
        answer:
          'Use in-app messages and the campaign record first. For account or safety issues, contact support.',
      },
      {
        question: 'What is not allowed?',
        answer:
          'Harassment, fraud, fake engagement, or ghosting. Repeated violations can cost platform access.',
      },
    ],
  },
];
